import React, { useState, useEffect } from 'react';
import { Autocomplete } from '@material-ui/lab';
import { Chip, TextField, Typography } from '@material-ui/core';

import { useDebounce } from '../../../../../../hooks/useDebounce';
import { producaov2 } from '../../../../../../services/apis';

const normalizeProducts = (products = []) => {
  return products?.map(product => {
    return {
      id: product?.id,
      name: product?.curso,
      price: product?.valor
    }
  })
}

export default function ProductField({ selectedProduct, onChangeProduct, autoFocus, error, helperText }) {
  const [products, setProducts] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [search, setSearch] = useState('');
  const debouncedSearch = useDebounce(search);
  
  useEffect(() => {
    let isMounted = true;

    const getProducts = async () => {
      try {
        const response = await producaov2.get('curso', {
          params: {
            search: debouncedSearch,
            ativo: 'S'
          }
        });

        if(!isMounted) {
          return;
        }

        setProducts(normalizeProducts(response.data) || []);

      } catch(error) {
        console.log(error);

        setProducts([]);
      } finally {
        setIsLoading(false);
      }
    }

    getProducts();

    return () => { isMounted = false }
  }, [debouncedSearch]);

  const handleSearchChange = (search) => {
    if(!isLoading) {
      setIsLoading(true);
    }
  
    setSearch(search);
  }

  const handleChangeProduct = (product) => {
    onChangeProduct(product);
    setSearch('');
  }
  
  return (
    !!selectedProduct ? (
      <Chip
        color="primary"
        label={<Typography variant="subtitle1">{`${selectedProduct?.name}`}</Typography>}
        onDelete={() => handleChangeProduct(null)}
      />
    ) : (
      <Autocomplete
        autoFocus={autoFocus}
        clearOnEscape
        selectOnFocus
        handleHomeEndKeys
        options={products}
        loading={isLoading}
        value={selectedProduct}
        inputValue={search}
        noOptionsText="Nenhum produto encontrado"
        onInputChange={(event, newValue) => handleSearchChange(newValue)}
        onChange={(event, newValue) => handleChangeProduct(newValue)}
        getOptionSelected={(option, value) => option?.id === value?.id}
        getOptionLabel={product => product ? `${product?.id} - ${product?.name}` : ''}
        InputProps={{
          error,
          helperText
        }}
        renderInput={(params) => (
          <TextField {...params}  label="Busque um produto" />
        )}
      />
    )
  )
}